import { useEffect } from "react";

/** Event name fired by the global Quick Edit FAB after a successful apply. */
export const QUICK_EDIT_EVENT = "ap:quick-edit-applied";

/**
 * Hook for pages that want to re-fetch their data whenever the global
 * Quick Edit FAB applies changes. Pass the function that re-loads
 * the page's data and add any dependencies it relies on.
 *
 * @example
 *   useQuickEditRefresh(load);
 */
export function useQuickEditRefresh(reload, deps = []) {
  useEffect(() => {
    if (typeof reload !== "function") return undefined;
    const handler = () => reload();
    window.addEventListener(QUICK_EDIT_EVENT, handler);
    return () => window.removeEventListener(QUICK_EDIT_EVENT, handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
